import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { FaChevronLeft } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'

import { Box, Button, Grid } from '@mui/material'
import { Edit } from '@mui/icons-material'

import { Form, Formik } from 'formik'

import SubmitButton from 'components/atoms/buttons/SubmitButton'
import InputField from 'components/atoms/fields/InputField'

import formModel, { initialValues, validationSchema } from 'utils/formModels/setupEntityModel'
import { crudColorMap, crudIconMap } from 'utils/helpers'

import { ActionType } from 'types'
import useCrudData from 'utils/customHooks/useCrudData'

interface IProps {
  action: ActionType
  id: string
  viewOnly: boolean
  entityType: string
  entityName: string
  getEntityQuery: any
  createEntityMutation: any
  editEntityMutation: any
  deleteEntityMutation: any
}

const SetupEntityForm: FC<IProps> = ({
  action, 
  id, 
  viewOnly, 
  entityType, 
  entityName,
  getEntityQuery,
  createEntityMutation,
  editEntityMutation,
  deleteEntityMutation
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()


  const backToSlug =`/setup/${entityType}/list`
  const editSlug = `/setup/${entityType}/list/edit/${id}`

  const {
    isLoading,
    entity,
    handleSubmit,
  } = useCrudData({
    backToSlug,
    entityName: entityName,
    entityId: id,
    getEntityQuery: getEntityQuery,
    createEntityMutation: createEntityMutation,
    editEntityMutation: editEntityMutation,
    deleteEntityMutation: deleteEntityMutation
  })

  const {
    title,
  } = formModel()
  
  const serverValues = entity?.id
    ? {
        ...entity,
      }
    : null

  return (
    <Formik
      enableReinitialize
      initialValues={serverValues || initialValues}
      validationSchema={validationSchema}
      onSubmit={(values: any) => {

        const data: any = {
          ...values,
        }

        handleSubmit(action, id, data)
      }}
    >
      <Form>
        <Grid container spacing={4} sx={{ marginTop: '-1rem' }}>
          <Grid item xs={12}>
            <InputField fieldProps={{ ...title }} disabled={viewOnly} />
          </Grid>

          <Grid item xs={12}>
            <Box sx={{ display: 'flex' }} className="transparent-background">
              <Button
                variant='outlined'
                color='black'
                onClick={() => navigate(backToSlug)}
                sx={{ minHeight: '2.5rem', width: '10rem' }}
              >
                <FaChevronLeft style={{ fontSize: '1.1rem', margin: '-3px 0.5rem 0 -0.5rem' }} />
                {`${t('common.back')}`}
              </Button>
              {action === 'view' && 
                <Box sx={{ marginLeft: 'auto' }}>
                  <Button
                    variant='outlined'
                    color='black'
                    onClick={() => navigate(editSlug)}
                    sx={{ minHeight: '2.5rem', width: '10rem' }}
                  >
                    <Edit style={{ fontSize: '1.1rem', margin: '-3px 0.5rem 0 -0.5rem' }} />
                    {`${t('common.edit')}`}
                  </Button>
                </Box>
              }
              {action !== 'view' && (
                <SubmitButton
                  color={crudColorMap[action]}
                  text={`${t('form-actions.' + action)}`}
                  icon={crudIconMap[action]}
                  sx={{ width: '10rem' }}
                  isLoading={isLoading}
                />
              )}
            </Box>
          </Grid>
        </Grid>
      </Form>
    </Formik>
  )
}
export default SetupEntityForm
